// app/javascript/controllers/discount_controller.js
import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["discount", "discountPercent", "finalPrice", "effectivePrice"];
  static values = {
    currencySymbol: String,
    totalPrice: Number,
    storageArraysDuration: Number,
  };

  connect() {
    this.updatePercentField();
    this.updateEffectivePriceField();
    this.setupListeners();
  }

  setupListeners() {
    this.addEventListeners(this.discountTarget, ["keyup", "change"], this.handleDiscountChange.bind(this));
    this.addEventListeners(this.discountPercentTarget, ["keyup", "change"], this.handlePercentChange.bind(this));
    this.addEventListeners(this.finalPriceTarget, ["keyup", "change"], this.handleFinalPriceChange.bind(this));

    this.addEventListeners(this.discountTarget, ["blur"], this.formatDiscountField.bind(this));
    this.addEventListeners(this.discountPercentTarget, ["blur"], this.formatPercentField.bind(this));
    this.addEventListeners(this.finalPriceTarget, ["blur"], this.formatFinalPriceField.bind(this));
  }

  handleDiscountChange() {
    this.updatePercentField();
    this.updateFinalPriceField();
    this.updateEffectivePriceField();
  }

  handlePercentChange() {
    let totalPrice = this.extractValue(this.totalPriceValue);
    let discountPercent = this.extractValue(this.discountPercentTarget.value);

    let discount = Math.round((totalPrice * discountPercent) / 100);
    let finalPrice = totalPrice - discount;

    this.discountTarget.value = this.formatCurrency(discount);
    this.finalPriceTarget.value = this.formatCurrency(finalPrice);

    this.updateEffectivePriceField();
  }

  handleFinalPriceChange() {
    this.updateDiscountField();
    this.updatePercentField();
    this.updateEffectivePriceField();
  }

  addEventListeners(target, events, handler) {
    events.forEach(event => target?.addEventListener(event, handler));
  }

  updatePercentField() {
    let discount = this.extractValue(this.discountTarget.value);
    let totalPrice = this.extractValue(this.totalPriceValue);

    let discountPercent = (discount / totalPrice) * 100;
    this.discountPercentTarget.value = this.formatPercent(discountPercent);
  }

  updateDiscountField() {
    let finalPrice = this.extractValue(this.finalPriceTarget.value);
    let totalPrice = this.extractValue(this.totalPriceValue);

    let discount = totalPrice - finalPrice;
    this.discountTarget.value = this.formatCurrency(discount);
  }

  updateFinalPriceField() {
    let discount = this.extractValue(this.discountTarget.value);
    let totalPrice = this.extractValue(this.totalPriceValue);

    let finalPrice = totalPrice - discount;
    this.finalPriceTarget.value = this.formatCurrency(finalPrice);
  }

  formatDiscountField() {
    this.discountTarget.value = this.formatCurrency(this.extractValue(this.discountTarget.value));
  }

  formatPercentField() {
    this.discountPercentTarget.value = this.formatPercent(this.extractValue(this.discountPercentTarget.value));
  }

  formatFinalPriceField() {
    this.finalPriceTarget.value = this.formatCurrency(this.extractValue(this.finalPriceTarget.value));
  }

  updateEffectivePriceField() {
    if (!this.hasEffectivePriceTarget) {
      return;
    }

    if (!this.storageArraysDurationValue) {
      this.effectivePriceTarget.innerText = '-';
      return;
    }

    let finalPrice = this.extractValue(this.finalPriceTarget.value);
    this.effectivePriceTarget.innerText = this.formatCurrency(Math.round(finalPrice / this.storageArraysDurationValue));
  }

  formatCurrency(value) {
    const number = parseFloat(value) || 0;
    return this.currencySymbolValue + ' ' + number.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'");
  }

  formatPercent(percent) {
    return `${(parseFloat(percent) || 0).toFixed(2)}%`;
  }

  extractValue(value) {
    if (typeof value === "number") {
      return value;
    }
    if (typeof value === "string") {
      return parseFloat(value.replace(/[^0-9.,-]/g, "").replace(/'/g, "") || "0");
    }
    return 0;
  }
}
